import React from 'react'

const MainStaticTitle = ({ containerObject, templateName, contentId, dataZone }) => {
  return (

<h2 className='right-panel-heading mb-3 mt-2'  dangerouslySetInnerHTML={{ __html: containerObject.attributes.staticTitle }}></h2>
  )
}

export default MainStaticTitle